import React from 'react';
import { whyMultiIon } from '../data/mock';
import { ArrowRight, CheckCircle2 } from 'lucide-react';

const WhyMultiIonSection = () => {
  return (
    <section id="why-multi-ion" className="relative py-16 sm:py-20 lg:py-24 bg-gray-950 overflow-hidden" data-testid="why-multi-ion-section">
      {/* Background elements */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/10 border border-emerald-500/30 mb-5">
            <CheckCircle2 className="w-4 h-4 text-emerald-400" />
            <span className="text-emerald-400 text-xs sm:text-sm font-semibold uppercase tracking-wider">The Solution</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            {whyMultiIon.title}
          </h2>
          <p className="text-gray-400 text-base sm:text-lg max-w-2xl mx-auto">
            {whyMultiIon.subtitle}
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-gray-800/30 border border-white/10 rounded-2xl overflow-hidden backdrop-blur-sm">
          {/* Table Header */}
          <div className="grid grid-cols-4 bg-gray-900/50">
            <div className="p-4 sm:p-5 font-semibold text-sm text-gray-400">Metric</div>
            <div className="p-4 sm:p-5 font-semibold text-sm text-amber-400 border-l border-white/5">Lithium-Ion</div>
            <div className="p-4 sm:p-5 font-semibold text-sm text-emerald-400 border-l border-white/5">Multi-Ion</div>
            <div className="p-4 sm:p-5 font-semibold text-sm text-gray-400 border-l border-white/5 hidden sm:block">Business Impact</div>
          </div>
          
          {/* Table Rows */}
          {whyMultiIon.comparisons.map((row, index) => (
            <div 
              key={index} 
              className={`grid grid-cols-4 ${index % 2 === 0 ? 'bg-gray-800/20' : 'bg-gray-800/40'} border-t border-white/5 hover:bg-gray-800/50 transition-colors`}
            >
              <div className="p-4 sm:p-5">
                <span className="font-semibold text-white text-sm">{row.metric}</span>
              </div>
              <div className="p-4 sm:p-5 border-l border-white/5">
                <span className="text-amber-400/70 text-sm">{row.lithium}</span>
              </div>
              <div className="p-4 sm:p-5 border-l border-white/5">
                <span className="text-emerald-400 font-semibold text-sm">{row.multiIon}</span>
              </div>
              <div className="p-4 sm:p-5 border-l border-white/5 hidden sm:block">
                <span className="text-gray-400 text-sm">{row.outcome}</span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 text-center">
          <a 
            href="#contact"
            className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white px-6 py-3 rounded-xl font-semibold transition-all"
          >
            Get Technical Specifications
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        {/* Note */}
        <p className="text-gray-500 text-sm mt-8 text-center">
          * Performance data based on standard test conditions. Contact engineering for application-specific specifications.
        </p>
      </div>
    </section>
  );
};

export default WhyMultiIonSection;
